import { z } from 'zod';

import { SUPPLIER_ACTIVATION_RESPOND_ACTION } from '../constants';

/**
 * Zod schema for the POST /api/v1/suppliers/activation/{req_id}/respond request payload.
 */
export const zodSupplierActivationRespondPayloadSchema = z.object({
  action: z.enum(SUPPLIER_ACTIVATION_RESPOND_ACTION),
  customerNumbers: z.array(z.string()).max(20).nullish(),
  declineReason: z.string().trim().nullish(),
});
